import { render, staticRenderFns } from "./campaignManagement.vue?vue&type=template&id=31f59790&scoped=true&"
import script from "./campaignManagement.vue?vue&type=script&lang=js&"
export * from "./campaignManagement.vue?vue&type=script&lang=js&"
import style0 from "./campaignManagement.vue?vue&type=style&index=0&id=31f59790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f59790",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VFlex,VLayout,VTab,VTabItem,VTabs,VTabsItems})
